import React from 'react';
import styles from './errorText.module.scss';

export const ErrorText = ({label, id, display}) => (
  <p id={id} className={styles.errorText} style={{ display: display ? 'block' : 'none' }}>
    {label}
  </p>
);